import React from "react";
import { Select } from "antd";
import ReactCountryFlag from "react-country-flag";
import "./BrdgxCountrySelector_new.css";

class BrdgxCountrySelector extends React.Component {
  render() {
    const { countries, style, size, placeholder, onChange, value, mode } = this.props;

    console.log("Selected value:", value);

    return (
      <Select
        showSearch
        className="country-selector"
        style={{ ...style }}
        size={size}
        placeholder={placeholder}
        optionFilterProp="children"
        onChange={onChange}
        value={value || undefined}
        mode={mode || "default"}
      >
        {countries.map((country) => {
          // console.log(`Country object:`, country);
          const displayName = country.country === "OTHERS" ? "GLOBAL" : country.country;

          return (
            <Select.Option
              value={country.countryCode}
              key={country.countryCode}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              {displayName !== "GLOBAL" && (
                <ReactCountryFlag
                  code={country.isoCodeAlpha2}
                  svg
                  style={{ marginRight: '10px', width: '1.5em', height: '1.5em' }}
                />
              )}
              <span style={{ marginLeft: displayName !== "GLOBAL" ? '10px' : '0', marginRight: 'auto', lineHeight: '1.5em' }}>
                {displayName}
              </span>
            </Select.Option>
          );
        })}
      </Select>
    );
  }
}

export default BrdgxCountrySelector;
